<template>
  <div class="invoice-related invoice-related-quotes">
    <div v-if="totalItems" class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>CATEGORY</th>
            <th>ITEM</th>
            <th>DETAILS</th>
            <th>QTY/HOURS</th>
            <th>MARKUP</th>
            <th>COST RATE</th>
            <th>COST</th>
            <th>QUOTE RATE</th>
            <th>QUOTED</th>
            <th width="120" class="text-right">MOVE TO INVOICE</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in relatedItems" :key="index">
            <td>{{ item.cost?item.cost.category.name:'' }}</td>
            <td>{{ item.cost?item.cost.description:'' }}</td>
            <td>{{ item.details }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.quantity*(item.quote_rate-item.cost_rate) | moneyFormat }}</td>
            <td>${{ item.cost_rate }}</td>
            <td>${{ item.cost_rate*item.quantity | numberFormat }}</td>
            <td>${{ item.quote_rate }}</td>
            <td>${{ item.quote_rate*item.quantity | numberFormat}}</td>
            <td align="right">
              <a v-if="!item.invoiced" href="javascript:;" class="icon-down-arrow" v-tooltip="'Move'" @click="moveToInvoice(index, item.id)"></a>
              <span v-else class="icon-checkmark"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 v-else><span v-if="state==''">No related quote items.</span></h4>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ServiceInvoice from '@/services/invoice'
export default {
  data () {
    return {
      state: '',
      relatedItems: [],
      totalItems: 0
    }
  },
  props: ['reload'],
  watch: {
    reload: 'init'
  },
  computed: {
    ...mapGetters(['INVOICE']),
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.getApprovedItems();
    },
    getApprovedItems () {
      let self = this;
      if (!self.INVOICE.job_id)
        return [];

      let params = {
        job_id: self.INVOICE.job_id,
        status: 'approved'
      };
      self.state = 'loading';
      ServiceInvoice.getQuoteItems(self.INVOICE.id, params, resp => {
        self.state = '';
        self.relatedItems = resp;
        self.totalItems = window.numkeys(self.relatedItems);
      });
    },
    moveToInvoice (index, item_id) {
      let self = this;
      ServiceInvoice.moveItemToInvoice(self.INVOICE.id, {type: 'quote', id: item_id}, addedInvoiceItem => {
        self.$notify({
          type: 'success',
          text: 'Quote item moved successfully'
        });
        self.$emit('item-saved', addedInvoiceItem, -1);
        self.relatedItems[index].invoiced = true;
      });
    }
  }
}
</script>
